import React, { useEffect } from 'react';
import { useHarvestingContext } from 'src/views/harvesting/harvesting-context'; 
import { useNavigate } from 'react-router-dom';
import { useFirestore } from 'reactfire';
import { doc,getDoc } from 'firebase/firestore'; 
import LoadingView from 'src/views/auth/LoadingView';
import { useAlertContext } from 'src/context/AlertContext';


const ShareFruitToOthers = () => {
  const {addFruits,allFruits} = useHarvestingContext();
  const navigate = useNavigate();
  const {useErrorAlert, useAlert} = useAlertContext();
  const db = useFirestore();

  useEffect(async() => {
    const SID = window.location.search
      .split('?')[1]
      .split('&')
      .filter((x) => x.split('=')[0] === 'SID')[0]
      .split('=')[1];

    const docSnap= await getDoc(doc(db, 'shareFishes',SID));
    if (docSnap.exists()) {
      if (doc) {
        addFruits(docSnap.data().output);
        navigate('/app/harvesting/');
        useAlert('Recieved fruit successfully','success');
      } else {
        useErrorAlert('Link doesn`t exist');
        // navigate('/app/harvesting/');
      }
    } else {
      useErrorAlert('Link doesn`t exist');
      // navigate('/app/harvesting/');
    }
  }, []);
  return <LoadingView/>;
};

export default ShareFruitToOthers;
